'use strict';

const KlarnaHelper = function () {
    function getPaymentMethodCategory(selectedPaymentMethod) {
        switch (selectedPaymentMethod) {
            case 'klarna_account':
                return 'pay_over_time';
            case 'klarna':
            case 'klarna_b2b':
                return 'pay_later';
            case 'klarna_paynow':
                return 'pay_now';
            default:
                return null;
        }
    }

    function init(selectedPaymentMethod, adyenData, callbackFunction) {
        const paymentMethodCategory = getPaymentMethodCategory(selectedPaymentMethod);
        if (!adyenData || !adyenData.clientToken) {
            callbackFunction({
                show_form: false /* eslint-disable-line camelcase */
            });
            return;
        }

        const script = document.getElementById('klarna-script');
        if (script) {
            script.parentNode.removeChild(script);
        }
        const recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('id', 'klarna-script');
        recaptchaScript.setAttribute('src', 'https://x.klarnacdn.net/kp/lib/v1/api.js');
        recaptchaScript.setAttribute('async', true);
        document.head.appendChild(recaptchaScript);
        /* eslint-disable no-undef, camelcase */
        window.klarnaAsyncCallback = function () {
            Klarna.Payments.init({
                client_token: adyenData.clientToken
            });

            Klarna.Payments.load(
                {
                    container: '#klarna-payments-container',
                    payment_method_category: paymentMethodCategory
                },
                callbackFunction
            );
        };
        /* eslint-enable no-undef, camelcase */
    }

    function authorize(selectedPaymentMethod, callbackFunction) {
        const paymentMethodCategory = getPaymentMethodCategory(selectedPaymentMethod);
        /* eslint-disable no-undef, camelcase */
        Klarna.Payments.authorize(
            {
                payment_method_category: paymentMethodCategory
            },
            {},
            callbackFunction
        );
        /* eslint-enable no-undef, camelcase */
    }

    return {
        init: init,
        authorize: authorize
    };
};

module.exports = new KlarnaHelper();
